export function validate(form: HTMLFormElement): boolean {
    let valid: boolean = true;
    const fields: NodeListOf<HTMLFormElement> = form.querySelectorAll('.is-required');

    fields.forEach((field: HTMLFormElement) => {
        if (field.value === '') {
            const parent: HTMLElement = field.parentElement;
            parent.classList.add('is-error');
            valid = false;
        }

        if (field.classList.contains('form__input--file')) {
            const { files } = field;

            if (!files[0]) {
                const parent: HTMLElement = field.closest('[data-form-file-button]');
                parent.classList.add('form__file--error');
                valid = false;
            }
        }
    });

    return valid;
}

export function serialize(form: HTMLFormElement): any {
    const data: any = {};
    const inputs: NodeListOf<HTMLInputElement> = form.querySelectorAll('input, select, textarea');

    inputs.forEach((input: HTMLInputElement) => {
        if (!input.classList.contains('form__input--file')) {
            data[input.name] = input.value;
        }
    });

    return data;
}

export function makeFormData(object: any): FormData {
    const data: FormData = new FormData();

    Object.keys(object).map((key) => {
        data.append(key, object[key]);
    });

    return data;
}

export function removeErrors(form: HTMLFormElement): void {
    const fields: NodeListOf<HTMLInputElement> = form.querySelectorAll('input, textarea');

    fields.forEach((field: HTMLInputElement) => {
        field.addEventListener('focus', () => {
            const parent: HTMLElement = field.parentElement;
            parent.classList.remove('is-error');
        });
    });
}

export function resetForm(form: HTMLFormElement): void {
    const fields: NodeListOf<HTMLInputElement> = form.querySelectorAll('input, textarea');

    fields.forEach((field: HTMLInputElement) => {
        field.value = '';
    });
}

export function addFiles(form: HTMLFormElement, data: FormData): FormData {
    const inputs: NodeListOf<HTMLFormElement> = form.querySelectorAll('.form__input--file');

    inputs.forEach((input: HTMLFormElement) => {
        const { files } = input;

        if (files[0]) {
            data.append(input.name, files[0]);
        }
    });

    return data;
}

export function uploadFile(button: HTMLElement): void {
    const file: HTMLFormElement = button.querySelector('[data-form-file]');

    button.addEventListener('click', () => {
        file.click();
    });

    file.addEventListener('change', (e: Event) => {
        const input = e.target as HTMLFormElement;
        const parent: HTMLElement = input.closest('[data-form-file-button]');
        const fileDefaultText: HTMLElement = parent.querySelector('[data-form-file-default-text]');
        const fileText: HTMLElement = parent.querySelector('[data-form-file-text]');
        const { files } = input;

        if (files.length) {
            fileText.innerText = files[0].name;
            parent.classList.remove('form__file--error');
            fileDefaultText.classList.remove('form__input-file-text--show');
            fileText.classList.add('form__input-file-text--show');
        } else {
            fileDefaultText.classList.add('form__input-file-text--show');
            fileText.classList.remove('form__input-file-text--show');
        }
    });
}
